export default __webpack_public_path__ + "static/media/overrightarrow~rQGIXioT.095d7ad0.svg";